export default __webpack_public_path__ + "static/media/ManropeExtraLight.d6763706.woff2";